module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_txt3_m_en.9efe1a6aa229b368f8786c22bd6e5021.png";